import { useRef, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { MenuItem } from '@mui/material'

import * as S from './styles'

export type SelectMenuProps = {
  id?: string
  label: string
  options: string[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  hasBorder?: boolean
}

export const SelectMenu: React.FC<SelectMenuProps> = ({
  id,
  label,
  options,
  value,
  onChange,
  disabled,
  hasBorder = true,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleSelect = (value: string) => {
    onChange(value)
    handleClose()
  }

  return (
    <div ref={containerRef}>
      <S.StyledButton
        aria-controls={open ? 'select-menu' : undefined}
        aria-describedby={id}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        disabled={disabled}
        disableElevation
        endIcon={<KeyboardArrowDownIcon color="primary" />}
        hasBorder={hasBorder}
        onClick={handleClick}
        open={open}
        variant="contained"
      >
        {label}
        {!!value && ` • ${value}`}
      </S.StyledButton>
      <S.StyledMenu
        anchorEl={anchorEl}
        elevation={0}
        id="select-menu"
        MenuListProps={{
          'aria-labelledby': id,
        }}
        minwidth={containerRef.current?.clientWidth}
        onClose={handleClose}
        open={open}
      >
        {options.map((option) => (
          <MenuItem key={option} onClick={() => handleSelect(option)}>
            {option}
          </MenuItem>
        ))}
      </S.StyledMenu>
    </div>
  )
}
